import IButton from '../../button/i-button.component';
import ITextInput from '../textfield/i-textinput.component';
import './i-searchfield.component.scss';
import { useState } from 'react';
import { EMPTY_STRING } from '../../../features/common/constants';

export interface ISearchFieldProps {
    onActionEvent?: any
}

const ISearchField = (props: ISearchFieldProps) => {
    const [searchText, setSearchText] = useState(EMPTY_STRING);
    const onActionEvent = () => {
        if (props.onActionEvent) {
            props.onActionEvent(searchText);
        }
    }

    const onChangeEvent = (e: any) => {
        setSearchText(e.target.value);
    }

    return <div className='search-field'>
        <ITextInput label={'Search'} name={searchText}
            onActionEvent={onChangeEvent}
            InputProps={{ sx: { borderRadius: 0, mr: 2 } }} />
        <IButton type='button' label='Search' onActionEvent={onActionEvent} />
    </div>

};

export default ISearchField;